<template>
  <div>
    <vs-table :max-items="5" pagination :data="billMasterList" search>
      <template slot="header">
        <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
          {{ $t("customers.label.invoice") }}
        </div>
        <span class="order-1">
          <vs-button
            icon-pack="feather"
            icon="icon-plus"
            size="small"
            @click="handleGenerate"
            >{{ $t("customers.label.generate") }}</vs-button
          >
        </span>
      </template>
      <template slot="thead">
        <vs-th>{{ $t("customers.label.bill_date") }}</vs-th>
        <vs-th>{{ $t("customers.label.due_date") }}</vs-th>
        <vs-th>{{ $t("customers.label.amount") }}</vs-th>
        <!-- <vs-th>{{ $t("customers.label.type") }}</vs-th> -->
        <vs-th class="tHeadCenter">{{ $t("customers.label.action") }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="index" v-for="(master, index) in data">
          <vs-td :data="getDate(master.billDate)">{{ getDate(master.billDate) }}</vs-td>
          <vs-td :data="getDate(master.dueDate)">{{ getDate(master.dueDate) }}</vs-td>
          <vs-td :data="master.amount">{{ master.amount }}</vs-td>
          <!-- <vs-td :data="master.type">{{ master.type }}</vs-td> -->
          <vs-td class="whitespace-no-wrap">
            <div class="container_img">
              <feather-icon
                title="View HTML"
                icon="FileTextIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click="viewHtml(master)"
                class="icon_row"
              />
              <feather-icon
                title="Save as PDF"
                icon="DownloadIcon"
                @click="downloadStatement(master.id)"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                class="icon_row text-warning"
              />
              <feather-icon
                title="Send Mail"
                icon="MailIcon"
                color="warning"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                class="icon_row"
                @click="sendEmail(master)"
              />
              <feather-icon
                v-if="index === data.length - 1"
                title="Cancel Invoice"
                icon="XCircleIcon"
                color="warning"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                class="icon_row"
                @click="
                  delId = master.id;
                  deleteInvoicePopup = true;
                "
              />
              <!-- <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                class="truncate donwloadbtn"
                size="small"
                @click=""
                >{{ $t("View collection") }}</vs-button
              > -->
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="centerx">
      <vs-popup
        :title="$t('customers.label.on_demand') + ' ' + $t('customers.label.invoice')"
        :active.sync="generate"
        class="popup-close"
      >
        <ValidationObserver ref="observer">
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <!-- <div class="vx-col mb-2 w-full">
                <small class="date-label font-semibold"
                  >{{ $t("customers.label.type")
                  }}<span class="required"> *</span></small
                >
                <v-select
                  v-model="makeStatement.generateType"
                  :options="['Trial', 'Actual']"
                  placeholder="Select Type"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                >
                </v-select>
              </div> -->
              <div class="vx-col mb-2 w-full">
                <vs-input
                  :label="$t('customers.label.due_date')"
                  class="w-full font-semibold mb-2"
                  v-model="makeStatement.dueDate"
                  disabled
                  icon-no-border
                />
              </div>
              <div class="vx-col mb-2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.process_date")
                    }}<span class="required">*</span></small
                  >
                  <datepicker
                    :placeholder="$t('customers.label.SelectDate')"
                    v-model="makeStatement.processDate"
                    class="mb-2 font-semibold"
                  />
                </div>
              </div>
              <div class="vx-col mb-2 w-full">
                <small class="date-label font-semibold"
                  >{{ $t("customers.label.invoice_type")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.invoice_type')"
                  :key="resetKey"
                >
                  <v-select
                    v-model="makeStatement.message"
                    :options="['Detail', 'Summary']"
                    :placeholder="$t('customers.label.SelectInvoiceType')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="center mb-2">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="addStatement"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.submit") }}</vs-button
                >
              </span>
            </div>
          </form>
        </ValidationObserver>
        <validation-popup
          :errorMessage="errorMessage"
          :warningPopup="warningPopup"
          :warningText="warningText"
          @closeWarning="warningPopup = false"
        ></validation-popup>
      </vs-popup>
    </div>
    <delete-popup
      :deletePopup="deleteInvoicePopup"
      title="Invoice"
      @deletePressed="deleteInvoiceMethod(delId)"
      @cancelPressed="deleteInvoicePopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import Datepicker from "vuejs-datepicker";
import { sendBillMasterEmail } from "@/http/customer/customer";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { BUCKET_BASE_URL } from "@/http/index";
import { mapState } from "vuex";

const statementEmpty = {
  message: "",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  dueDate: moment().add(10, "days").format("DD MMMM YYYY"),
  processDate: moment().format("DD MMMM YYYY"),
};
export default {
  props: ["clientId"],
  data() {
    return {
      generate: false,
      statement: [],
      resetKey: 0,
      deleteInvoicePopup: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      makeStatement: { ...statementEmpty },
    };
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    billMasterList() {
      return this.$store.getters["customerAccount/getBillMasterData"];
    },
  },
  methods: {
    getDate(dateArray) {
      const date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
      const formattedDate = moment(date).format(this.formattedDate);
      return formattedDate;
    },
    handleGenerate() {
      this.resetKey++;
      this.generate = true;
    },
    async getBillMaster() {
      try {
        //const resp = await getClientBillMaster(this.clientId);
        this.$store.dispatch("customerAccount/setBillMasterData", this.clientId);
      } catch (e) {
        console.log("Something went wrong while retrieving client bill master: ", e);
      }
    },
    async deleteInvoiceMethod(invoiceId) {
      const payload = {
        clientId: this.clientId,
        resourceId: invoiceId,
        changes: {},
        resourceIdentifier: invoiceId,
      };
      try {
        await this.$store.dispatch("customer/deleteInvoiceAction", payload);
        this.deleteInvoicePopup = false;
        await this.getBillMaster();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Invoice Deleted Successfully!",
          type: "success",
        });
      } catch (e) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Something Went Wrong!",
          type: "error",
        });
      }
    },
    viewHtml(item) {
      this.$router.push({
        name: "View Statement",
        params: { id: item.id, customerId: this.clientId },
      });
    },
    async sendEmail(item) {
      try {
        await this.$store.dispatch("customerAccount/sendBillMasterEmail", {
          id: item.id,
          data: {
            statementId: item.id,
          },
        });
        this.$vs.notify({
          title: "Mail Sent",
          text: "Mail Sent SuccessFully",
          iconPack: "feather",
          icon: "check-circle",
          color: "success",
        });
      } catch (e) {
        this.$vs.notify({
          title: "Failed!",
          text: e.defaultUserMessage,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      }
    },
    async addStatement() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      try {
        await this.$store.dispatch("customer/createStatement", {
          id: this.clientId,
          data: this.makeStatement,
        });
        this.generate = false;
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Statement Created Successfully!",
          type: "success",
        });
        this.makeStatement = { ...sendBillMasterEmail };
        this.makeStatement.dueDate = moment().add(10, "days").format("DD MMMM YYYY");
        this.makeStatement.processDate = moment().format("DD MMMM YYYY");
        this.getClient();
        this.getBillMaster();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async downloadStatement(id) {
      try {
        const bearerToken = sessionStorage.getItem("ngb:bearer_token") || null;
        const response = await fetch(
          `${BUCKET_BASE_URL}/billmaster/${id}/print?tenantIdentifier=default`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${bearerToken}`,
            },
          }
        );
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `statement_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading the statement:", error);
        this.$vs.notify({
          title: "Download Failed",
          text: "Unable to download the statement. Please try again.",
          color: "danger",
        });
      }
    },
    async getClient() {
      try {
        const data = await this.$store.dispatch(
          "customer/setClientDetailData",
          this.$route.params.id
        );
        this.makeStatement.message = data.data.invoiceType;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  components: {
    quillEditor,
    Datepicker,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  created() {
    this.getBillMaster();
    this.getClient();
  },
};
</script>
<style lang="scss" scoped></style>
